
const SET_SME_QUICK_FORM = 'SET_SME_QUICK_FORM'
const SET_ESTIMATED_PREMIUM  = 'SET_ESTIMATED_PREMIUM'
const SET_SME_QUOTE_INFORMATION_FORM  = 'SET_SME_QUOTE_INFORMATION_FORM'


const state = {
  smeQuickForm: null,
  estimatedPremium:null,
  smeQuoteInformationForm: null,
}


const mutations = {
  [SET_SME_QUICK_FORM]: (state, value) => {
    state.smeQuickForm= value
  },
  [SET_ESTIMATED_PREMIUM]: (state, value) => {
    state.estimatedPremium= value
  },
  [SET_SME_QUOTE_INFORMATION_FORM]: (state, value) => {
    state.smeQuoteInformationForm= value
  },
}

const actions = {
  setSmeQuickForm({ commit }, val) {
    commit(SET_SME_QUICK_FORM, val)
  },
  setSMEQuoteInformationForm({ commit }, val) {
    commit(SET_SME_QUOTE_INFORMATION_FORM, val)
  },
  setEstimatedPremium({ commit }, val) {
    commit(SET_ESTIMATED_PREMIUM, val)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
